import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IFilterTabsState } from '../models/filter-tabs.models';

export interface FilterTabsRepository {
    load(listKey: string): Observable<IFilterTabsState | null>;
    save(listKey: string, state: IFilterTabsState): Observable<void>;
}

export const FILTER_TABS_REPOSITORY = new InjectionToken<FilterTabsRepository>('FilterTabsRepository');
